export default "/_next/static/chunks/fonts/Roboto-Thin-latin-3f29bbd806ee648b72ffcd7bfc5bad56.woff2";